import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Menu from "./components/menu/Menu.js";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" exact element={<Menu />} />
      </Routes>
    </Router>
  );
};

export default App;